/** @jsxImportSource @emotion/react */

import { QRCode } from "antd";
// import { ReactComponent as IconTelevison } from "assets/Common/icons/icon-television.svg";
import AndroidIcon from "assets/Desktop/icons/homepage/androidIcon.png";
import IosIcon from "assets/Desktop/icons/homepage/IosIcon.png";
import AppDownLoad from "assets/Desktop/images/homepage/appDownload.png";
import SwiperBottomSwiper from "assets/Desktop/images/homepage/swiper-bottom.png";
import HelmetCustom from "components/Common/HelmetCustom";
import MatchSchedule from "components/Common/MatchSchedule";
import NotificationCustom from "components/Common/NotificationCustom";
import Container from "components/Desktop/base/Container";
import DetailAnnouncement from "components/Desktop/ui/DetailAnnouncement";
import GaugeItem from "components/Desktop/ui/GaugeItemHomepage";
import { LIST_ITEM_GAUGE } from "components/Desktop/ui/GaugeItemHomepage/list-item";
import ServiceItem from "components/Desktop/ui/ServiceItemHomepage";
import { LIST_ITEM_SERVICE } from "components/Desktop/ui/ServiceItemHomepage/list-item";
import { URL_DOWNLOAD_ANDROID, URL_DOWNLOAD_IOS } from "contants/common";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useScrollTop } from "hooks/useScrollTop";
import {
  LegacyRef,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import {
  selectHasShownHomeModalAfterLogin,
  selectHomeAnnouncementDetail,
  setHasShownHomeModalAfterLogin,
} from "store/announcement";
import { getHomeAnnouncement } from "store/announcement/announcement.thunk";
import { selectIsAuthenticated } from "store/auth";
import { OpenDetailsType } from "types/announcement";

import Banner from "./Banner";
import { HomePageStyle } from "./index.style";
import OurPartners from "./OurPartners";
import SEO from "./SEO";
import { ArrowNextCustom, ArrowPrevCustom } from "./Swiper/ArrowCustom";
import CategorySwiper from "./Swiper/categorySwiper";
import { LIST_CATEGORY_SWIPER } from "./Swiper/categorySwiper/list-category";
import GameSwiper from "./Swiper/gamesSwiper";
import { LIST_GAMES_SWIPER } from "./Swiper/gamesSwiper/list-game";

const initStateDetails: OpenDetailsType = {
  visible: false,
  dataItem: undefined,
};

const HomePage = () => {
  useScrollTop();

  const dispatch = useAppDispatch();
  const isAuth = useAppSelector(selectIsAuthenticated);
  const announcementDetail = useAppSelector(selectHomeAnnouncementDetail);
  const hasShownHomeModalAfterLogin = useAppSelector(
    selectHasShownHomeModalAfterLogin
  );

  const { t } = useTranslation("home");
  // const username = useAppSelector(selectUsername);

  const [state, setState] = useState<OpenDetailsType>(initStateDetails);

  const sliderRefBelow: MutableRefObject<Slider | null | undefined> = useRef();
  const sliderRefAbove: MutableRefObject<Slider | null | undefined> = useRef();

  useEffect(() => {
    dispatch(getHomeAnnouncement());
  }, [dispatch]);

  useEffect(() => {
    if (!isAuth) {
      dispatch(setHasShownHomeModalAfterLogin(false));
      setState(initStateDetails);
      return;
    }

    if (!announcementDetail || hasShownHomeModalAfterLogin) return;

    setState({
      visible: true,
      dataItem: announcementDetail,
    });
    dispatch(setHasShownHomeModalAfterLogin(true));
  }, [announcementDetail, dispatch, hasShownHomeModalAfterLogin, isAuth]);

  // const handleredirectLink = () => {
  //   if (!username) {
  //     dispatch(setOpenModal("signin"));
  //   } else {
  //     window.open("https://m.crichd.vip/web007");
  //   }
  // };

  return (
    <div css={HomePageStyle.wrapper.index}>
      <HelmetCustom />
      <Banner />
      <NotificationCustom />
      <div css={HomePageStyle.overview.index}>
        <Container>
          <div css={HomePageStyle.wrapper.title}>{t("Product")}</div>
          <div css={HomePageStyle.wrapper.describe}>{t("ContentProduct")}</div>
          <Slider
            css={HomePageStyle.overview.categorySwiper}
            slidesToShow={6}
            focusOnSelect={true}
            ref={sliderRefAbove as LegacyRef<Slider> | undefined}
          >
            {LIST_CATEGORY_SWIPER.map((item, index: number) => (
              <div
                key={item.key}
                onClick={() => {
                  sliderRefBelow.current?.slickGoTo(index);
                }}
              >
                <CategorySwiper key={item.key} {...item} />
              </div>
            ))}
          </Slider>

          <Slider
            css={HomePageStyle.overview.gamesSwiper}
            centerPadding="20px"
            centerMode={true}
            ref={sliderRefBelow as LegacyRef<Slider> | undefined}
            slidesToShow={3}
            nextArrow={
              <ArrowNextCustom
                sliderRefBelow={sliderRefBelow}
                sliderRefAbove={sliderRefAbove}
              />
            }
            prevArrow={
              <ArrowPrevCustom
                sliderRefBelow={sliderRefBelow}
                sliderRefAbove={sliderRefAbove}
              />
            }
            touchMove={false}
          >
            {LIST_GAMES_SWIPER.map((item) => (
              <GameSwiper key={item.key} {...item} />
            ))}
          </Slider>
          <div css={HomePageStyle.imgBottom}>
            <img src={SwiperBottomSwiper} alt="" />
          </div>
        </Container>
      </div>

      <section css={HomePageStyle.info.index}>
        <Container>
          {/* <button css={HomePageStyle.info.btnLink} onClick={handleredirectLink}>
            <IconTelevison />
            {t("CricketLive")}
          </button> */}
          <div css={HomePageStyle.info.header.index}>
            <div css={HomePageStyle.wrapper.title}>{t("APP DOWNLOAD")}</div>
            <div css={HomePageStyle.wrapper.describe}>{t("TitleDownload")}</div>
          </div>
          <div css={HomePageStyle.info.bottom.index}>
            <div css={HomePageStyle.info.bottom.image}>
              <img src={AppDownLoad} alt="" />
            </div>
            <div css={HomePageStyle.info.bottom.content}>
              <div css={HomePageStyle.cardInner}>
                <h2>{t("TitleContentDownload")}</h2>
                <p>{t("ContentDownload")}</p>
                <div css={HomePageStyle.sectionQr}>
                  <div css={HomePageStyle.blockQr}>
                    <QRCode value={URL_DOWNLOAD_IOS} size={110} />
                    <div css={HomePageStyle.blockIconQr}>
                      <img src={IosIcon} alt="" />
                      <span>{t("Apple iOS")}</span>
                    </div>
                  </div>
                  <div css={HomePageStyle.blockQr}>
                    <QRCode value={URL_DOWNLOAD_ANDROID} size={110} />
                    <div css={HomePageStyle.blockIconQr}>
                      <img src={AndroidIcon} alt="" />
                      <span>{t("Android")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <Container>
        <div css={HomePageStyle.service.header}>
          <div css={HomePageStyle.wrapper.title}>{t("Excellent Service")}</div>
          <div css={HomePageStyle.wrapper.describe}>{t("TitleExcellent")}</div>
        </div>
        <section
          css={[HomePageStyle.service.content, HomePageStyle.service.grid_4]}
        >
          {LIST_ITEM_GAUGE.map((item, index) => (
            <GaugeItem key={index} {...item} />
          ))}
        </section>

        <section
          css={[HomePageStyle.service.content, HomePageStyle.service.grid_2]}
        >
          {LIST_ITEM_SERVICE.map((item, index) => (
            <ServiceItem key={index} {...item} />
          ))}
        </section>
        <div css={HomePageStyle.matchSeoSection}>
          <MatchSchedule />
          <SEO />
        </div>
        <OurPartners />
      </Container>
      <DetailAnnouncement
        details={state}
        onClose={() =>
          setState((prev) => ({
            ...prev,
            visible: false,
          }))
        }
      />
    </div>
  );
};

export default HomePage;
